/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { EngagementTemplate } from '../../data/types';

export type EngagementTemplateState = {
    engagementTemplates: EngagementTemplate[],
}

export const useEngagementTemplateState = () => {
    const engagementTemplateState = useSelector((state: RootState | any) => state.engagementTemplates as EngagementTemplateState);
    return engagementTemplateState;
}

// Define the initial state using that type
const initialState: EngagementTemplateState = {
    engagementTemplates: [],
}

export const engagementTemplateSlice = createSlice({
    name: 'engagementTemplates',
    initialState: initialState,
    reducers: {
        setEngagementTemplatesAction: (state, action: PayloadAction<EngagementTemplate[]>) => {
            state.engagementTemplates = action.payload;
        },
        addOrReplaceEngagementTemplateAction: (state, action: PayloadAction<EngagementTemplate>) => {
            const existingIndex = state.engagementTemplates.findIndex((eDocTemplate: EngagementTemplate) => eDocTemplate?.templateId === action.payload.templateId);
            if (existingIndex >= 0) {
                state.engagementTemplates[existingIndex] = action.payload;
            } else {
                state.engagementTemplates.push(action.payload);
            }
        },
        deleteEngagementTemplateAction: (state, action: PayloadAction<EngagementTemplate>) => {
            state.engagementTemplates = state.engagementTemplates.filter((x) => x.templateId !== action.payload.templateId);
        },
    }
})

export const { addOrReplaceEngagementTemplateAction, setEngagementTemplatesAction, deleteEngagementTemplateAction } = engagementTemplateSlice.actions;

export default engagementTemplateSlice.reducer;